var _polyline, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFileInPlaylist(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    transform: "matrix(.0536 0 0 .0514 1.34 1.96)",
    points: "60 160 60 300 130 300",
    fill: "none",
    stroke: "#000",
    strokeWidth: 8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.0535 0 0 .0539 1.88 1.73)",
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8.12,
    y: 10.9,
    width: 292,
    height: 149,
    fill: "none",
    strokeWidth: 11.8
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 10
  }, /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 65,
    width: 40,
    height: 40,
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 140,
    x2: 260,
    y1: 65,
    y2: 65
  }), /*#__PURE__*/React.createElement("line", {
    x1: 140,
    x2: 260,
    y1: 105,
    y2: 105
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.0535 0 0 .0539 8.3 12)",
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 250,
    height: 180,
    fill: "none",
    strokeWidth: 12
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 10
  }, /*#__PURE__*/React.createElement("line", {
    x1: 30,
    x2: 220,
    y1: 50,
    y2: 50
  }), /*#__PURE__*/React.createElement("line", {
    x1: 30,
    x2: 220,
    y1: 90,
    y2: 90
  }), /*#__PURE__*/React.createElement("line", {
    x1: 30,
    x2: 220,
    y1: 130,
    y2: 130
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileInPlaylist);
export default __webpack_public_path__ + "static/media/file-in-playlist.2954a10e.svg";
export { ForwardRef as ReactComponent };